import script from "./tmanager.vue?vue&type=script&setup=true&lang=js"
export * from "./tmanager.vue?vue&type=script&setup=true&lang=js"

import "./tmanager.vue?vue&type=style&index=0&id=0a269233&lang=scss"

const __exports__ = script;

export default __exports__